<template>
  <UnstyledCta class="CtaButton" :class="{ hasTallIcon }" v-bind="{ action, text }" @click="$attrs.onClick">
    {{ text }}
    <span v-if="icon === 'arrow'" class="icon arrowIcon" v-html="arrowRightSvg" />
    <span v-if="icon === 'download'" class="icon downloadIcon" v-html="downloadSvg" />
  </UnstyledCta>
</template>

<script>
import arrowRightSvg from '~/assets/ui/button-arrow-right.svg?raw'
import colors from './colors.json'
import downloadSvg from '~/assets/ui/button-download.svg?raw'
import UnstyledCta from './UnstyledCta.vue'

export default {
  components: {
    UnstyledCta,
  },
  props: {
    text: String,
    action: String,
    icon: String,
  },
  data() {
    return {
      arrowRightSvg,
      colors,
      downloadSvg,
    }
  },
  computed: {
    hasTallIcon() {
      return this.icon === 'download'
    }
  },
}
</script>

<style scoped>

.CtaButton {

  /* geometry */
  display: inline-block;
  border-radius: 4px;
  border-width: 2px;
  border-style: solid;
  padding: var(--spacing-4) var(--spacing-7);

  /* text */
  font-weight: 400;
  font-size: var(--font-size-3);
  line-height: 1;
  text-align: center;
  white-space: nowrap;

  transition: all 0.15s;
}

.CtaButton.hasTallIcon {
  line-height: 1.5;
}

.CtaButton:focus {
  outline: none;
}

.CtaButton[disabled] {
  /* These rules are !important in order to override the various color rules defined below */
  background-color: transparent !important;
  border-color: v-bind('colors.lightGray') !important;
  color: v-bind('colors.darkGray') !important;
}

.CtaButton .icon {
  /* Give this elem a fixed height so the svg it contains doesn't push out the height of the button */
  display: inline-block;
  height: 1em;
}

.CtaButton .icon:deep(svg) {
  display: inline-block;
  width: 1em;
  margin-left: 0.75em;
  position: relative;
  left: 0;
  transition: left 0.15s;
}

.CtaButton .arrowIcon:deep(svg) {
  width: 1em;
}

.CtaButton .downloadIcon:deep(svg) {
  width: 1.5em;
  top: -3px;
}

.CtaButton:hover .arrowIcon:deep(svg) {
  left: 3px;
}

.CtaButton.--bright-blue {
  background-color: v-bind('colors.brandColor');
  border-color: v-bind('colors.brandColor');
  color: var(--text-color-white);
}

.CtaButton.--bright-blue:hover {
  background-color: v-bind('colors.brandColorLighter');
  border-color: v-bind('colors.brandColorLighter');
}

.CtaButton.--bright-blue:focus {
  background-color: v-bind('colors.brandColorLight');
  border-color: v-bind('colors.brandColor');
}

.CtaButton.--dark-blue {
  background-color: v-bind('colors.darkestBlue');
  border-color: v-bind('colors.darkestBlue');
  color: var(--text-color-white);
}

.CtaButton.--dark-blue:hover {
  background-color: v-bind('colors.brandColorDark');
  border-color: v-bind('colors.brandColorDark');
}

.CtaButton.--dark-blue:focus {
  background-color: v-bind('colors.brandColorDark');
  border-color: v-bind('colors.brandColorDarkest');
}

.CtaButton.--outline {
  background-color: transparent;
  border-color: var(--text-color-black);
  color: var(--text-color-black);
}

.CtaButton.--outline:hover {
  background-color: v-bind('colors.darkestBlue');
  color: var(--text-color-white);
}

.CtaButton.--outline:focus {
  background-color: v-bind('colors.darkerBlue');
  border-color: v-bind('colors.darkestBlue');
  color: var(--text-color-white);
}
</style>
